import { differenceInHours, startOfDay } from 'date-fns';

const MIN_DAYS_DIFFERENCE = 1;
export const differenceToNowInDaysRoundedUp = (date: Date) =>
  Math.round(Math.abs(differenceInHours(startOfDay(Date.now()), date)) / 24) || MIN_DAYS_DIFFERENCE;
